import type { Provider } from '../../holistic/types/HolisticSummary';
import { requestBuilder } from '../../http/RequestBuilder';
import type { IGoalAccountLink } from '../types/Goal';

interface CreateGoalAccountLinkBody {
    goalId: string;
    accountId: string;
    provider: Provider;
}

const useCreateGoalAccountLink = requestBuilder.mutation<
    IGoalAccountLink,
    CreateGoalAccountLinkBody
>({
    endpoint: () => `/api/guidance/goals/account-link`,
    method: 'POST',
});

export default useCreateGoalAccountLink;
